(function() {
  if (window.LmpLuxSearchLoaded) return;
  window.LmpLuxSearchLoaded = true;

  function formatMoney(cents, currency) {
    if (typeof cents !== 'number') return '';
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function initLuxSearch(wrapper) {
    if (!wrapper || wrapper.dataset.lmpLuxReady === 'true') return;
    wrapper.dataset.lmpLuxReady = 'true';

    var input = wrapper.querySelector('[data-search-input]');
    var dropdown = wrapper.querySelector('[data-search-dropdown]');
    var resultsContainer = wrapper.querySelector('[data-search-results]');
    var endpoint = wrapper.getAttribute('data-search-url');
    var searchResultsUrl = wrapper.getAttribute('data-search-results-url');

    if (!input || !dropdown || !resultsContainer || !endpoint || !searchResultsUrl) return;

    var activeIndex = -1;
    var activeLinks = [];
    var debounceTimer = null;
    var abortController = null;

    function openDropdown() {
      dropdown.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function closeDropdown() {
      dropdown.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
      activeLinks = [];
    }

    function renderSection(title, itemsHtml) {
      if (!itemsHtml) return '';
      return '<div class="lmp-lux-search__dropdown-section"><div class="lmp-lux-search__dropdown-title">' + title + '</div><div class="lmp-lux-search__dropdown-list">' + itemsHtml + '</div></div>';
    }

    function renderProduct(product) {
      var imageHtml = '';
      if (product.featured_image && product.featured_image.url) {
        imageHtml = '<span class="lmp-lux-search__thumb"><img src="' + product.featured_image.url + '&width=88" alt="' + escapeHtml(product.title) + '" loading="lazy"></span>';
      }

      var priceHtml = '';
      if (product.price && typeof product.price.min === 'number') {
        priceHtml = '<span class="lmp-lux-search__price">' + formatMoney(product.price.min, product.price.currency_code) + '</span>';
      }

      return '<a class="lmp-lux-search__dropdown-link" href="' + product.url + '"><span class="lmp-lux-search__dropdown-main">' + imageHtml + '<span class="lmp-lux-search__item-text"><span class="lmp-lux-search__item-title">' + escapeHtml(product.title) + '</span></span></span>' + priceHtml + '</a>';
    }

    function renderSimple(item) {
      return '<a class="lmp-lux-search__dropdown-link" href="' + item.url + '"><span class="lmp-lux-search__dropdown-main"><span class="lmp-lux-search__item-text"><span class="lmp-lux-search__item-title">' + escapeHtml(item.title) + '</span></span></span></a>';
    }

    function renderQuery(item) {
      var queryText = item.text || item.styled_text || item.title || '';
      if (!queryText) return '';
      var queryUrl = searchResultsUrl + '?q=' + encodeURIComponent(queryText) + '&type=product,article,page&options%5Bprefix%5D=last';
      return '<a class="lmp-lux-search__dropdown-link" href="' + queryUrl + '"><span class="lmp-lux-search__dropdown-main"><span class="lmp-lux-search__item-text"><span class="lmp-lux-search__item-title">' + escapeHtml(queryText) + '</span><span class="lmp-lux-search__item-meta">Suchvorschlag</span></span></span></a>';
    }

    function updateActiveLink() {
      activeLinks.forEach(function(link, index) {
        if (index === activeIndex) {
          link.classList.add('is-active');
          link.scrollIntoView({ block: 'nearest' });
        } else {
          link.classList.remove('is-active');
        }
      });
    }

    function renderResults(query, data) {
      var predictive = data && data.resources && data.resources.results ? data.resources.results : null;
      if (!predictive) {
        resultsContainer.innerHTML = '<div class="lmp-lux-search__empty">Keine Vorschläge gefunden.</div>';
        openDropdown();
        return;
      }

      var queriesHtml = (predictive.queries || []).map(renderQuery).join('');
      var productsHtml = (predictive.products || []).map(renderProduct).join('');
      var collectionsHtml = (predictive.collections || []).map(renderSimple).join('');
      var pagesHtml = (predictive.pages || []).map(renderSimple).join('');
      var articlesHtml = (predictive.articles || []).map(renderSimple).join('');

      var html = '';
      html += renderSection('Suchvorschläge', queriesHtml);
      html += renderSection('Produkte', productsHtml);
      html += renderSection('Kategorien', collectionsHtml);
      html += renderSection('Seiten', pagesHtml);
      html += renderSection('Beiträge', articlesHtml);

      if (!html) {
        html = '<div class="lmp-lux-search__empty">Keine Vorschläge für „' + escapeHtml(query) + '“ gefunden.</div>';
      }

      html += '<div class="lmp-lux-search__footer"><a class="lmp-lux-search__footer-link" href="' + searchResultsUrl + '?q=' + encodeURIComponent(query) + '&type=product,article,page&options%5Bprefix%5D=last">Alle Ergebnisse für „' + escapeHtml(query) + '“ anzeigen</a></div>';

      resultsContainer.innerHTML = html;
      activeLinks = Array.prototype.slice.call(resultsContainer.querySelectorAll('.lmp-lux-search__dropdown-link'));
      activeIndex = -1;
      openDropdown();
    }

    function fetchResults(query) {
      if (abortController) abortController.abort();
      abortController = new AbortController();
      var baseUrl = endpoint.replace(/\/$/, '') + '.json';
      var params = new URLSearchParams({
        q: query,
        'resources[type]': 'product,collection,page,article,query',
        'resources[limit]': '8',
        'resources[limit_scope]': 'each',
        'resources[options][fields]': 'title,product_type,variants.title,tag',
        'resources[options][unavailable_products]': 'hide'
      });

      fetch(baseUrl + '?' + params.toString(), {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
        signal: abortController.signal
      })
      .then(function(response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function(data) { renderResults(query, data); })
      .catch(function(error) {
        if (error.name === 'AbortError') return;
        resultsContainer.innerHTML = '<div class="lmp-lux-search__empty">Die Vorschläge konnten gerade nicht geladen werden.</div>';
        openDropdown();
      });
    }

    input.addEventListener('input', function() {
      var query = input.value.trim();
      clearTimeout(debounceTimer);
      if (query.length < 2) {
        closeDropdown();
        return;
      }
      debounceTimer = setTimeout(function() { fetchResults(query); }, 180);
    });

    input.addEventListener('keydown', function(event) {
      if (dropdown.hidden || !activeLinks.length) {
        if (event.key === 'Escape') closeDropdown();
        return;
      }

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        activeIndex = activeIndex < activeLinks.length - 1 ? activeIndex + 1 : 0;
        updateActiveLink();
      }

      if (event.key === 'ArrowUp') {
        event.preventDefault();
        activeIndex = activeIndex > 0 ? activeIndex - 1 : activeLinks.length - 1;
        updateActiveLink();
      }

      if (event.key === 'Enter' && activeIndex >= 0 && activeLinks[activeIndex]) {
        event.preventDefault();
        window.location.href = activeLinks[activeIndex].getAttribute('href');
      }

      if (event.key === 'Escape') closeDropdown();
    });

    input.addEventListener('focus', function() {
      if (resultsContainer.innerHTML.trim() !== '' && input.value.trim().length >= 2) openDropdown();
    });

    document.addEventListener('click', function(event) {
      if (!wrapper.contains(event.target)) closeDropdown();
    });
  }

  function boot() {
    document.querySelectorAll('[data-lmp-predictive-search]').forEach(initLuxSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
